import PropTypes from 'prop-types';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import VideoGradientIcon from '../../../../assets/svg/video-gradient.svg?react';
import classNames from 'classnames';
import { useMemo } from 'react';
import FJUtil from '../../../../util/FJUtil';
import FJConstant from '../../../../constants/FJConstant';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJLocalStore from '../../../../store/FJLocalStore';
import DownloadIcon from '../../../../assets/svg/download-black.svg?react';

import styles from './FJHairstyleChangerRight.module.less';

function FJHairstyleChangerRight(props) {
    const {
        uploadImg,
        setIsDraggingFile,
        taskStatus,
        headerTabIndex,
        isCanDownload,
        download,
        imageToVideo,
        downloadEditImageLoading,
        onRetry,
    } = props;

    const currentTag = FJLocalStore.currentTag();

    const rightChildren = useMemo(() => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return null;
        }

        if (window.isEditPage) return null;

        return (
            <div className={styles.right_btn_box}>
                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.image_to_video_btn)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('image-to-video')}
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon className={styles.image_to_video_icon} />}
                />

                <FJButton
                    onClick={download}
                    className={classNames(styles.download, downloadEditImageLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadEditImageLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [download, imageToVideo, downloadEditImageLoading, taskStatus, headerTabIndex, isCanDownload, currentTag]);

    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer isShowProgress={false} rightChildren={rightChildren} hideCancelButton />

            <FJCreationPanelContainer
                activeHeaderTabIndex={FJConstant.CREATIONS}
                onRetry={onRetry}
                bkColor='var(--bg-color-sub)'
            />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
}

FJHairstyleChangerRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    onRetry: PropTypes.func,
    taskStatus: PropTypes.string,
    headerTabIndex: PropTypes.string,
    isCanDownload: PropTypes.bool,
    download: PropTypes.func,
    downloadEditImageLoading: PropTypes.bool,
    imageToVideo: PropTypes.func,
};

export default FJHairstyleChangerRight;
